import { Section } from '../../models/menu.interfaces';

export const SkyMilesSectionMocks: Section = {
  id: 'skyMiles',
  title: 'My SkyMiles',
  items: [
    {
      id: 'overview',
      link: {
        label: 'Overview',
        url: '/myskymiles/overview'
      },
      selected: true
    },
    {
      id: 'account-activity',
      link: {
        label: 'Account Activity',
        url: '/myskymiles/accountactivity'
      },
      selected: false
    },
    {
      id: 'benefits',
      link: {
        label: 'Member Benefits',
        url: '/overview#benefits'
      },
      selected: false
    },
    {
      id: 'promotions',
      link: {
        label: 'Promotions',
        url: '/myskymiles/promotions'
      },
      selected: false
    },
    {
      id: 'partner-network',
      link: {
        label: 'Partner Network',
        url: '/myskymiles/partner-network'
      },
      selected: false
    },
    {
      id: 'buy-gift-transfer-donate-miles',
      link: {
        label: 'Buy, Gift or Transfer Miles',
        url: '/us/en/skymiles/how-to-use-miles/buy-gift-transfer-donate-miles'
      },
      selected: false
    }
  ],
  url: '',
  opened: true
};
